import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Submenu from 'uiKit/submenu/Submenu'
import Loader from 'uiKit/loaders/loader'
import { HOME_PATH } from 'configs'
import { setBrowserTabTitle } from 'helpers/setBrowserTabTitle'
import { dataRoutes } from '../../routes/dataRoutes'

interface Props {
  activeBot: any
  match: any
}

const Data: React.FC<Props> = ({ activeBot, match }) => {
  const pathLink = `${HOME_PATH}/bot/${match.params.botId}/data`
  const pathRoute = `${HOME_PATH}/bot/:botId/data/`

  useEffect(() => {
    setBrowserTabTitle(`${activeBot?.name} - Data`)
  }, [activeBot])

  if (!activeBot) return <Loader />

  return (
    <div style={{ minHeight: '100%', height: '100%' }}>
      {/*<div style={{ height: '100%', position: 'sticky', top: 0 }}>*/}
      <Submenu pathLink={pathLink} pathRoute={pathRoute} routes={dataRoutes} />
    </div>
  )
}

const mapStateToProps = (state: { activeBot: any }) => ({
  activeBot: state.activeBot,
})

export default withRouter(connect(mapStateToProps)(Data))
